import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as CloseCircle } from "assets/close-circle.svg";

const MobileNavbar = ({ pathname, timeLeft }) => {
  const { t } = useTranslation("event");

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const scrollToSection = (id) => {
    // if (pathname !== "/") {
    //   navigate("/");
    //   setTimeout(() => {
    //     document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    //   }, 100);
    // } else {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setIsSidebarOpen(!isSidebarOpen);
    // }
  };
  return (
    <div>
      <button
        onClick={toggleSidebar}
        className={`lg:hidden fixed z-50 top-6 right-4 text-black`}
      >
        <svg
          className={`h-6 w-6 ${
            isSidebarOpen || pathname !== "/" ? "text-black" : "text-gray-50"
          }`}
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M13.3333 4.66675L2.66659 4.66675"
            stroke="#121212"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            opacity="0.5"
            d="M13.3333 8L2.66659 8"
            stroke="#121212"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M13.3333 11.3333L2.66659 11.3333"
            stroke="#121212"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </button>

      <div
        className={`lg:hidden fixed bg-white  ${
          isSidebarOpen ? "inset-y-[70px]" : "inset-y-0"
        } left-0 w-full z-40 transform transition-transform duration-300 ease-in-out h-fit ${
          isSidebarOpen ? "translate-y-0" : "-translate-y-full"
        }`}
      >
        <div
          className={`flex p-6 pt-8 flex-col bg-white  items-start justify-start font-[Manrope] gap-10 max-lg:gap-5 text-black text-[14px] overflow-y-auto
            h-fit
          relative`}
        >
          <CloseCircle
            className="absolute top-6 right-6 cursor-pointer"
            onClick={() => setIsSidebarOpen(false)}
          />
          <button onClick={() => scrollToSection("home")}>
            {t("navlinks.home")}
          </button>

          <button onClick={() => scrollToSection("about")}>
            {t("navlinks.about")}
          </button>

          <button onClick={() => scrollToSection("sponsors")}>
            {t("navlinks.sponsors")}
          </button>

          <button onClick={() => scrollToSection("speakers")}>
            {t("navlinks.speakers")}
          </button>

          <button onClick={() => scrollToSection("agenda")}>
            {t("navlinks.agenda")}
          </button>
          <div className="flex text-base font-normal text-black">
            <span>
              {timeLeft.days}D {" : "}
            </span>
            <span>
              {timeLeft.hours}H {" : "}
            </span>
            <span>{timeLeft.minutes}M</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileNavbar;
